import { useState } from "react";
import { Chip, type ChipProps, Stack, Tooltip, Typography } from "@mui/material";
import t from "./translations";

const DEFAULT_MAX = 2;

export default function ExpandableChips({
  ids,
  labelMap,
  max = DEFAULT_MAX,
  chipVariant = "filled",
}: {
  ids: number[];
  labelMap: Map<number, string>;
  max?: number;
  chipVariant?: ChipProps["variant"];
}) {
  const [expanded, setExpanded] = useState(false);

  if (ids.length === 0) {
    return (
      <Typography variant="body2" color="text.secondary">
        —
      </Typography>
    );
  }
  const visible = expanded ? ids : ids.slice(0, max);
  const overflow = ids.length - max;
  return (
    <Stack sx={{ flexDirection: "row", flexWrap: "wrap", gap: 0.5, py: 0.5 }}>
      {visible.map((id) => {
        const label = labelMap.get(id);
        const chip = (
          <Chip
            key={id}
            label={label ?? id}
            size="small"
            variant={chipVariant}
            color={label === undefined ? "error" : "default"}
          />
        );
        return label === undefined ? (
          <Tooltip key={id} title={t.InaccessibleProject} arrow placement="bottom">
            <span>{chip}</span>
          </Tooltip>
        ) : (
          chip
        );
      })}
      {overflow > 0 && (
        <Chip
          label={expanded ? "−" : `+${overflow}`}
          size="small"
          variant="outlined"
          onClick={() => setExpanded(!expanded)}
          sx={{ cursor: "pointer" }}
        />
      )}
    </Stack>
  );
}
